'use strict';

import register from './core';
import '../functions/jquery-global.js';

register('radiogroup', function(element) {

    var $radioGroup = $(element),
        $radioButtons = $radioGroup.find('.button'),
        keyCode = Object.freeze({
            'TAB': 9,
            'SPACE': 32,
            'LEFT': 37,
            'UP': 38,
            'RIGHT': 39,
            'DOWN': 40
        }),
        setChecked = function(item) {

            var $item = $(item),
                $input = $item.prev();

          $radioGroup.attr('aria-activedescendant', $input.attr('id'));
          $radioButtons.attr('tabindex', '-1');
          $item.attr('tabindex', '0').focus();
          $input.prop('checked', true).trigger('change');
        },
        setCheckedToPreviousItem = function(item) {
            var currentIndex = $radioButtons.index(item);

            if (currentIndex === 0) {
                setChecked($radioButtons.last());
            }
            else {
                setChecked($($radioButtons[currentIndex - 1]));
            }
        },
        setCheckedToNextItem = function(item) {
            var currentIndex = $radioButtons.index(item);

            if (currentIndex === $radioButtons.length - 1) {
                setChecked($radioButtons.first());
            }
            else {
                currentIndex = $radioButtons.index(item);
                setChecked($($radioButtons[currentIndex + 1]));
            }
        };

    $(function() {
        var attr = $radioGroup.attr('aria-activedescendant');
      if (!$radioGroup.attr('aria-activedescendant')) {
        $radioButtons.first().attr('tabindex', '0');
      }
    });

    $radioButtons.on('click', function(e) {
        setChecked(this);
    });

    $radioButtons.on('keydown', function(e) {
      var flag = false,
          $item = $(this);

      switch (e.keyCode) {
        case keyCode.SPACE:
          case keyCode.RETURN:
              setChecked($item);
              flag = true;
            break;

        case keyCode.UP:
          setCheckedToPreviousItem($item);
              flag = true;
          break;

        case keyCode.DOWN:
          setCheckedToNextItem($item);
              flag = true;

          break;

        case keyCode.LEFT:
          setCheckedToPreviousItem($item);
              flag = true;
          break;

        case keyCode.RIGHT:
          setCheckedToNextItem($item);
              flag = true;
          break;

          default:
          break;
      }

      if (flag) {
          e.stopImmediatePropagation();
          e.preventDefault();
      }
    });
});
